import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=a34c7c20&"
import script from "./HeroSection.vue?vue&type=script&lang=js&"
export * from "./HeroSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports